import { __ } from '@wordpress/i18n'
import { useState } from 'react';
import { useLayouts } from '../LayoutsProvider';

export default function DeleteLayout(props) {

    const { closeModal, postID }      = props;
    const { refreshLayouts }          = useLayouts();
    const [isDeleting, setIsDeleting] = useState(false);
    const [showError, setShowError]   = useState(false);

    const deleteLayout = () => {
        setIsDeleting(true);
        setShowError(false);
        fetch(responsive_addons_site_builder.rest_url + 'site-builder-layouts/' + postID, {
            method: "DELETE",
            headers: {
                "X-WP-Nonce": responsive_addons_site_builder.nonce,
            },
        })
            .then((res) => {
                if (!res.ok) {
                    setShowError(true);
                    throw new Error(`HTTP error! status: ${res.status} => ${res.statusText}`);
                }
                return res.json();
            })
            .then((data) => {
                closeModal();
                refreshLayouts();
            })
            .catch((err) => {
                setShowError(true);
                console.error("Fetch error:", err)
            })
            .finally(()=>setIsDeleting(false));
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
			<div className="bg-white rounded-lg shadow-lg p-8 w-full max-w-max text-center">
				<h2 className="text-2xl font-semibold text-center text-black mb-3">
					{__('Move to Trash', 'responsive-addons')}
				</h2>
				<p className="text-[16px] text-gray-700 mb-6">
					{__('Are you sure you want to move this item to trash?', 'responsive-addons')}
				</p>
                {/* Show error if failed to delete the layout */}
                {showError && (
                    <div className="mb-5 rounded-md border border-red-300 bg-red-50 px-4 py-3 text-sm text-red-800">
                        {__("Failed to delete the layout. Please try again.", "responsive-addons")}
                    </div>
                )}
				<div className="flex justify-center gap-4">
					<button
						onClick={closeModal}
						className="px-4 py-2 rounded bg-white text-black hover:bg-gray-100 transition border border-[#53515A]"
					>
						{__('Cancel', 'responsive-addons')}
					</button>
					<button
						onClick={deleteLayout}
						disabled={isDeleting}
						className={`px-6 py-2 rounded-md font-medium transition focus:outline-none focus:ring-2 focus:ring-offset-2 ${
                            isDeleting
                                ? 'bg-[#C53030] text-white cursor-not-allowed'
                                : 'bg-[#FF5151] text-white hover:text-white hover:bg-[#E04444]'
                        }`}
					>
						{isDeleting
							? __('Deleting...', 'responsive-addons')
							: __('Move to Trash', 'responsive-addons')}
					</button>
				</div>
			</div>
		</div>
    )
}